// TYPES
export const INIT_APP_LIST = 'INIT_APP_LIST';
export const SAVE_SEARCH_PARMS = 'SAVE_SEARCH_PARMS';

export const SEARCH_APP_LIST = 'SEARCH_APP_LIST';
export const SEARCH_APP_LIST_SUCCESS = 'SEARCH_APP_LIST_SUCCESS';
export const INFINITE_SEARCH_APP_LIST = 'INFINITE_SEARCH_APP_LIST';
export const INFINITE_SEARCH_APP_LIST_SUCCESS =
  'INFINITE_SEARCH_APP_LIST_SUCCESS';

export const SEARCH_SUBSCRIPTION = 'SEARCH_SUBSCRIPTION';
export const SEARCH_SUBSCRIPTION_SUCCESS = 'SEARCH_SUBSCRIPTION_SUCCESS';
export const SEARCH_PLAN_UW_HISTORY_LIST = 'SEARCH_PLAN_UW_HISTORY_LIST';
export const SEARCH_PLAN_UW_HISTORY_LIST_SUCCESS =
  'SEARCH_PLAN_UW_HISTORY_LIST_SUCCESS';
export const SEARCH_PLAN_SUBSCRIPTION_RECEPT_HISTORY_LIST =
  'SEARCH_PLAN_SUBSCRIPTION_RECEPT_HISTORY_LIST';
export const SEARCH_PLAN_SUBSCRIPTION_RECEPT_HISTORY_LIST_SUCCESS =
  'SEARCH_PLAN_SUBSCRIPTION_RECEPT_HISTORY_LIST_SUCCESS';
export const SEARCH_SUBSCRIPTION_SHARED_LP_LIST =
  'SEARCH_SUBSCRIPTION_SHARED_LP_LIST';
export const SEARCH_SUBSCRIPTION_SHARED_LP_LIST_SUCCESS =
  'SEARCH_SUBSCRIPTION_SHARED_LP_LIST_SUCCESS';
export const GET_SHARED_PLAN_INFO_SUCCESS = 'GET_SHARED_PLAN_INFO_SUCCESS';

export const SEARCH_DIAGNOSIS_CUSTOMER = 'SEARCH_DIAGNOSIS_CUSTOMER';
export const SEARCH_DIAGNOSIS_CUSTOMER_SUCCESS =
  'SEARCH_DIAGNOSIS_CUSTOMER_SUCCESS';

export const SAVE_DIAGNOSIS_CUSTOMER = 'SAVE_DIAGNOSIS_CUSTOMER';
export const SEND_SHARED_LP_SMS = 'SEND_SHARED_LP_SMS';
export const CHECK_SHARED_LP_SMS = 'CHECK_SHARED_LP_SMS';
export const RESET_SHARED_LP = 'RESET_SHARED_LP';
export const COMPLETE_SHARED_LP = 'COMPLETE_SHARED_LP';

export const SEARCH_UNDECIDED_UW_HISTORY = 'SEARCH_UNDECIDED_UW_HISTORY';
export const SEARCH_UNDECIDED_UW_HISTORY_SUCCESS =
  'SEARCH_UNDECIDED_UW_HISTORY_SUCCESS';

export const SEARCH_UNDECIDED_HISTORY = 'SEARCH_UNDECIDED_HISTORY';
export const SEARCH_UNDECIDED_HISTORY_SUCCESS =
  'SEARCH_UNDECIDED_HISTORY_SUCCESS';
export const GET_POLICY_PDF_URL = 'GET_POLICY_PDF_URL';
export const SEND_POLICY_PDF_ALARM_TALK = 'SEND_POLICY_PDF_ALARM_TALK';
export const SEND_MOBILE_TERM_ALARM_TALK = 'SEND_MOBILE_TERM_ALARM_TALK';
export const POST_EACH_REISSUE_REPORT = 'POST_EACH_REISSUE_REPORT';
export const GET_DIGITAL_PARAMEDIC = 'GET_DIGITAL_PARAMEDIC';
export const SEND_DIGITAL_PARAMEDIC = 'SEND_DIGITAL_PARAMEDIC';
export const SEARCH_PLAN_SUBSCRIPTION_UNDECIDED_PRSS_HISTORY_LIST =
  'SEARCH_PLAN_SUBSCRIPTION_UNDECIDED_PRSS_HISTORY_LIST';
export const SEARCH_PLAN_UNDECIDED_PRSS_HISTORY_LIST_SUCCESS =
  'SEARCH_PLAN_UNDECIDED_PRSS_HISTORY_LIST_SUCCESS';
export const POST_ISSUE_VIR_ACC = 'POST_ISSUE_VIR_ACC';

export const CHECK_IDENTITY_CARD_APPLIST = 'CHECK_IDENTITY_CARD_APPLIST';

export const SEARCH_UNDECIDED_HISTORY_NO = 'SEARCH_UNDECIDED_HISTORY_NO';

export const SEARCH_UNDECIDED_HISTORY_NO_SUCCESS =
  'SEARCH_UNDECIDED_HISTORY_NO_SUCCESS';

export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';

// ACTIONS
export const initAppList = payload => {
  return { type: INIT_APP_LIST, payload };
};
export const saveSearchParms = payload => {
  return { type: SAVE_SEARCH_PARMS, payload };
};

export const searchAppList = payload => {
  return { type: SEARCH_APP_LIST, payload };
};
export const searchAppListSuccess = payload => {
  return { type: SEARCH_APP_LIST_SUCCESS, payload };
};
export const infiniteSearchAppList = payload => {
  return { type: INFINITE_SEARCH_APP_LIST, payload };
};
export const infiniteSearchAppListSuccess = payload => {
  return { type: INFINITE_SEARCH_APP_LIST_SUCCESS, payload };
};

export const searchSubscription = payload => {
  return { type: SEARCH_SUBSCRIPTION, payload };
};
export const searchSubscriptionSuccess = payload => {
  return { type: SEARCH_SUBSCRIPTION_SUCCESS, payload };
};

// 청약 심사 중 이력 조회
export const searchPlanUwHistoryList = payload => {
  return { type: SEARCH_PLAN_UW_HISTORY_LIST, payload };
};

// 청약 심사 중 이력 조회
export const searchPlanUwHistoryListSuccess = payload => {
  return { type: SEARCH_PLAN_UW_HISTORY_LIST_SUCCESS, payload };
};

// 청약 접수 진행 중 이력 조회
export const searchPlanSubscriptionReceptHistoryList = payload => {
  return { type: SEARCH_PLAN_SUBSCRIPTION_RECEPT_HISTORY_LIST, payload };
};

// 청약 접수 진행 중 이력 조회 성공
export const searchPlanSubscriptionReceptHistoryListSuccess = payload => {
  return {
    type: SEARCH_PLAN_SUBSCRIPTION_RECEPT_HISTORY_LIST_SUCCESS,
    payload,
  };
};

// 추가진단신청 고객정보 조회
export const searchDiagnosisCustomer = payload => {
  return { type: SEARCH_DIAGNOSIS_CUSTOMER, payload };
};

// 추가진단신청
export const saveAddDiagnosis = payload => {
  return { type: SAVE_DIAGNOSIS_CUSTOMER, payload };
};

// 공동 청약 LP정보 조회 조회
export const searchSubscriptionSharedLpList = payload => {
  return { type: SEARCH_SUBSCRIPTION_SHARED_LP_LIST, payload };
};

// 공동 청약 LP정보 조회 조회 성공
export const searchSubscriptionSharedLpListSuccess = payload => {
  return {
    type: SEARCH_SUBSCRIPTION_SHARED_LP_LIST_SUCCESS,
    payload,
  };
};

// 공동 청약 동의 인증번호 발송
export const sendSharedLpSms = payload => {
  return { type: SEND_SHARED_LP_SMS, payload };
};

// 공동 청약 동의 인증번호 확인
export const checkSharedLpSms = payload => {
  return { type: CHECK_SHARED_LP_SMS, payload };
};

// 공동 청약 동의 초기화
export const resetSharedLp = payload => {
  return { type: RESET_SHARED_LP, payload };
};

// 공동 청약 동의 초기화
export const completeSharedLp = payload => {
  return { type: COMPLETE_SHARED_LP, payload };
};

// 청약목록 > 심사보완내역 조회
export const searchUndecidedUwHistory = payload => {
  return { type: SEARCH_UNDECIDED_UW_HISTORY, payload };
};

// 청약목록 > 심사보완내역 조회 이력 상태 변경
export const searchUndecidedUwHistorySuccess = payload => {
  return { type: SEARCH_UNDECIDED_UW_HISTORY_SUCCESS, payload };
};

//청약목록 > 미결보완내역 횟수 조회
export const searchUndecidedHistoryNo = payload => {
  return { type: SEARCH_UNDECIDED_HISTORY_NO, payload };
};

//청약목록 > 미결보완내역 횟수 상태 변경
export const searchUndecidedHistoryNoSuccess = payload => {
  return { type: SEARCH_UNDECIDED_HISTORY_NO_SUCCESS, payload };
};

// 청약목록 > 미결보완내역 조회
export const searchUndecidedHistory = payload => {
  return { type: SEARCH_UNDECIDED_HISTORY, payload };
};

// 청약목록 > 미결보완내역 조회 상태 변경
export const searchUndecidedHistorySuccess = payload => {
  return { type: SEARCH_UNDECIDED_HISTORY_SUCCESS, payload };
};

// 청약목록 > 청약서 열람 url
export const getPolicyPdfUrl = payload => {
  return { type: GET_POLICY_PDF_URL, payload };
};

// 청약목록 > 더보기 > 부본 알림톡 발송
export const sendPolicyPdfAlarmTalk = payload => {
  return { type: SEND_POLICY_PDF_ALARM_TALK, payload };
};

// 청약목록 > 더보기 > 모바일 약관 알림톡을 재발송
export const sendMobileTermAlarmTalk = payload => {
  return { type: SEND_MOBILE_TERM_ALARM_TALK, payload };
};

/**
 * 청약서 부가서류 발행
 */
export const postEachReissueReport = ({
  applicationNo = '',
  policyNo = '',
  itemNo = '',
  itemSno = 0,
  undwTpCd = '',
  undwSno = 0,
  subscriptionDate = '',
  docTypeList = [],
  callback = undefined,
}) => ({
  type: POST_EACH_REISSUE_REPORT,
  payload: {
    applicationNo,
    policyNo,
    itemNo,
    itemSno,
    undwTpCd,
    undwSno,
    subscriptionDate,
    docTypeList,
    callback,
  },
});

// 건강평점 신청일자, 수신일자 조회
export const getDigitalParamedic = payload => {
  return { type: GET_DIGITAL_PARAMEDIC, payload };
};

// 건강평점 신청
export const sendDigitalParamedic = payload => {
  return { type: SEND_DIGITAL_PARAMEDIC, payload };
};

// 미결 중 처리이력 조회
export const searchPlanSubscriptionUndecidedPrssHistoryList = payload => {
  return {
    type: SEARCH_PLAN_SUBSCRIPTION_UNDECIDED_PRSS_HISTORY_LIST,
    payload,
  };
};

// 미결 중 처리이력 State 변경
export const searchPlanUndecidedPrssHistoryListSuccess = payload => {
  return {
    type: SEARCH_PLAN_UNDECIDED_PRSS_HISTORY_LIST_SUCCESS,
    payload,
  };
};

// 가상 계좌 재발급
export const postIssueVirAcc = payload => {
  return {
    type: POST_ISSUE_VIR_ACC,
    payload,
  };
};

// 실명증표 진위인증 (신분증인증)
export const checkIdentityCard = payload => {
  return { type: CHECK_IDENTITY_CARD_APPLIST, payload };
};

// 청약 취소
export const cancelSubscription = payload => {
  return { type: CANCEL_SUBSCRIPTION, payload };
};
